module.exports = __webpack_public_path__ + "static/media/map.3c8c52fe.jpg";